import "./css/global-reset.css";
import styles from "./css/app.module.css";
import { getLessonColours, lessons } from "./lessonsData";
import LabyrinthSvg from "./comps/labyrinthSvg/LabyrinthSvg";
import InfoPanel from "./comps/infoPanel/InfoPanel";
import LessonSelector from "./comps/lessonSelector/LessonSelector";
import LessonNumberNav from "./comps/lessonNumberNav/LessonNumberNav";

const lessonColours = getLessonColours(lessons);

function App({ lessonId }) {
  const currLessonId = lessonId ? lessonId : "intro";
  let currLesson = lessons.find((l) => l.id === currLessonId);
  if (!currLesson) currLesson = lessons[0];
  console.log("currLesson: ", currLesson);

  return (
    <div className={styles.app}>
      <header className={styles.header}>
        <h1 className={styles.title}>Lessons from the Labyrinth</h1>
        {/* <p className={styles.subtitle}>
          Extracts from the Lessons from the Labyrinth book of by Sarah Toraven.
        </p> */}
      </header>

      <div className={styles.labyrinth}>
        <div className={styles.stack}>
          <div className={styles.svgViewPanel}>
            <LabyrinthSvg
              currLesson={currLesson}
              lessonColours={lessonColours}
            />
            <LessonNumberNav currLesson={currLesson} lessons={lessons} />
          </div>

          <LessonSelector lessons={lessons} currLesson={currLesson} />
        </div>

        <InfoPanel currLesson={currLesson} />
      </div>
    </div>
  );
}

export default App;
